import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
    this.handleReload = this.handleReload.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary] Caught render error:", error, info);
  }

  handleReload() {
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return (
        <div style={styles.overlay}>
          <div style={styles.card}>
            <div style={styles.iconWrapper}>
              <span style={styles.icon}>&#9888;</span>
            </div>
            <h2 style={styles.title}>Something went wrong</h2>
            <p style={styles.message}>
              An unexpected error occurred. Please reload the page.
            </p>
            <button style={styles.button} onClick={this.handleReload}>
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const styles = {
  overlay: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    padding: "24px 16px",
    backgroundColor: "#f5f5f5",
    fontFamily: "sans-serif",
    boxSizing: "border-box",
  },
  card: {
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
    padding: "32px 24px",
    textAlign: "center",
    width: "100%",
    maxWidth: "360px",
    boxSizing: "border-box",
  },
  iconWrapper: {
    width: "52px",
    height: "52px",
    borderRadius: "50%",
    backgroundColor: "#fef3c7",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 20px",
  },
  icon: {
    fontSize: "22px",
    color: "#d97706",
    lineHeight: 1,
  },
  title: {
    margin: "0 0 10px",
    fontSize: "18px",
    fontWeight: "600",
    color: "#111827",
    lineHeight: "1.3",
  },
  message: {
    margin: "0 0 28px",
    fontSize: "14px",
    color: "#6b7280",
    lineHeight: "1.6",
  },
  button: {
    display: "block",
    width: "100%",
    backgroundColor: "#2563eb",
    color: "#ffffff",
    border: "none",
    borderRadius: "10px",
    padding: "13px 24px",
    fontSize: "15px",
    fontWeight: "500",
    cursor: "pointer",
    boxSizing: "border-box",
    minHeight: "48px",
  },
};